// #region Imports

import * as $ from "jquery";

// #endregion Imports

// #region Exports

export function wireSearchField(): void {
    $('.searchfield__input--large').on("input", handleInput);
}

// #endregion Exports

// #region Private functions

function handleInput(): void {
    const $input = $(this);
    const $placeholder = $input.next('.searchfield__placeholder');
    const $greeting = $placeholder.find(".searchfield__greeting");
    const $message = $placeholder.find(".searchfield__message");
    const value = $input.val().toString();

    $placeholder.show();

    if (value !== "") {
        $greeting.text(value);
        $greeting.addClass("searchfield__greeting--hidden");
        $message.addClass("searchfield__message--hidden");
    } else {
        $greeting.text($greeting.data("message"));
        $greeting.removeClass("searchfield__greeting--hidden");
        $message.removeClass("searchfield__message--hidden");
    }
}

// #endregion Private functions